/* KARMA PDP galéria: bélyeg-sín + lapozhato nagy kep.

   SZIN <-> KEP, mindket iranyban. A hozzarendeles forrasa a Shopify
   VARIANS->KEP kapcsolat (data-varszin a slide-okon, a v.featured_media-bol).

   A jelolt kep utani jeloletlen kepek (altpic-ek) oroklik az elottuk allo
   jelolt szinet. Ha egy kepnek igy sincs szine (pl. lifestyle), a szinkron
   nem csinal semmit.

   A "belsoValtas" zar vedi a hurkot: a galeriabol inditott szinvaltas nem
   gorgeti vissza a stripet a szin elso fotojara.

   - sin <-> strip ketiranyu szinkron (kattintas ill. gorgetes-kovetes)
   - utemezes setTimeout-tal (a rAF/IO hatterbe tett lapon fel van fuggesztve) */
(function () {
  var gal = document.querySelector('[data-karma-gal]');
  if (!gal) return;
  var strip = gal.querySelector('[data-gstrip]');
  var prog = gal.querySelector('[data-gprog]');
  var progCsik = gal.querySelector('[data-gthumb]');
  var slides = [].slice.call(gal.querySelectorAll('[data-gslide]'));
  var picks = [].slice.call(gal.querySelectorAll('[data-gpick]'));

  function norm(s) {
    return (s || '').toLowerCase()
      .replace(/[áàâä]/g, 'a').replace(/[éèêë]/g, 'e').replace(/[íìîï]/g, 'i')
      .replace(/[óòôöőõ]/g, 'o').replace(/[úùûüű]/g, 'u')
      .replace(/[^a-z0-9]/g, '');
  }
  /* --- a jelenleg valasztott szin --- */
  function aktivSzin() {
    var opt = gal.getAttribute('data-color-option');
    if (!opt) return null;
    var on = norm(opt);
    var fs = document.querySelectorAll('variant-selects fieldset, .product-form__input');
    for (var i = 0; i < fs.length; i++) {
      var lg = fs[i].querySelector('legend, .form__label');
      if (!lg || norm(lg.textContent).indexOf(on) !== 0) continue;
      var sel = fs[i].querySelector('input[type=radio]:checked');
      if (sel) return sel.value;
      var dd = fs[i].querySelector('select');
      if (dd) return dd.value;
    }
    return null;
  }

  /* --- KEP -> SZIN: melyik szin-ertekhez tartozik egy slide? ---
     A data-varszin a hiteles jel (varians->kep az adminbol); a jeloletlen
     altpic-ek a megelozo jelolt slide szinet oroklik. Lifestyle: soha. */
  var slideSzin = [];
  (function () {
    var vitt = '';
    slides.forEach(function (s, i) {
      if (s.hasAttribute('data-life')) { slideSzin[i] = ''; return; }
      var sajat = s.getAttribute('data-varszin') || '';
      if (sajat) vitt = sajat;
      slideSzin[i] = vitt;
    });
  })();

  function szinInputok() {
    var opt = gal.getAttribute('data-color-option');
    if (!opt) return [];
    var on = norm(opt);
    var fs = document.querySelectorAll('variant-selects fieldset, .product-form__input');
    for (var i = 0; i < fs.length; i++) {
      var lg = fs[i].querySelector('legend, .form__label');
      if (lg && norm(lg.textContent).indexOf(on) === 0)
        return [].slice.call(fs[i].querySelectorAll('input[type=radio]'));
    }
    return [];
  }
  var belsoValtas = false;
  function szinKovet(idx) {
    var sz = slideSzin[idx];
    if (!sz) return;                                   /* lifestyle / jeloletlen: marad */
    var mostani = aktivSzin();
    if (mostani === sz) return;
    /* PONTOS ertek-egyezes a radio value-val - semmi kozelites */
    var cel = szinInputok().filter(function (r) { return r.value === sz; })[0];
    if (!cel || cel.checked || cel.disabled) return;
    belsoValtas = true;
    /* Balint 2026-10-15: kep-lapozaskor a szinvaltas utan a Dawn ujrarajzolja a valasztot es a
       fokuszt a szin-gombra teszi -> mobilon a lap leugrott a szinvalasztohoz. A lapozo vevo a kepet
       nezi, ezert a gorgetesi helyzetet 1,5 mp-ig megtartjuk (a Dawn-fajlhoz nem nyulunk). */
    helyTart(1500);
    cel.checked = true;
    cel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function helyTart(ms) {
    var y = window.scrollY, ig = Date.now() + ms;
    function vissza() {
      if (Date.now() > ig) { window.removeEventListener('scroll', vissza); document.removeEventListener('focusin', fokusz, true); return; }
      if (Math.abs(window.scrollY - y) > 30) window.scrollTo(0, y);
    }
    function fokusz(e) {
      if (Date.now() > ig) return;
      var t = e.target;
      if (t && t.closest && t.closest('variant-selects')) { try { t.blur(); } catch (er) {} window.scrollTo(0, y); }
    }
    window.addEventListener('scroll', vissza, { passive: true });
    document.addEventListener('focusin', fokusz, true);
    setTimeout(vissza, ms + 20);
  }

  /* --- aktiv kep: sin-kiemeles + (kertre) oda-gorgetes --- */
  function kiemel(idx) {
    picks.forEach(function (p, j) { p.classList.toggle('is-on', j === idx); });
    var p = picks[idx];
    /* csak a sint gorgetjuk vizszintesen - a scrollIntoView mobilon az egesz lapot is mozgatta */
    var sin = p && p.parentElement;
    if (p && sin) {
      var bal = p.offsetLeft - sin.offsetLeft, jobb = bal + p.offsetWidth;
      if (bal < sin.scrollLeft) sin.scrollTo({ left: bal, behavior: 'smooth' });
      else if (jobb > sin.scrollLeft + sin.clientWidth) sin.scrollTo({ left: jobb - sin.clientWidth, behavior: 'smooth' });
      var ft = p.offsetTop - sin.offsetTop, la = ft + p.offsetHeight;
      if (ft < sin.scrollTop) sin.scrollTo({ top: ft, behavior: 'smooth' });
      else if (la > sin.scrollTop + sin.clientHeight) sin.scrollTo({ top: la - sin.clientHeight, behavior: 'smooth' });
    }
  }
  /* programozott ugras alatt a gorgetes-koveto ZARVA van, kulonben a smooth
     gorgetes kozben vegigugralna a kijeloles a kozbenso belyegeken */
  var zarva = false, zarIdozito = null;
  function ugrik(idx, sima) {
    var s = slides[idx];
    if (!s) return;
    kiemel(idx);
    zarva = true;
    clearTimeout(zarIdozito);
    zarIdozito = setTimeout(function () { zarva = false; }, 800);
    strip.scrollTo({ left: s.offsetLeft, behavior: sima ? 'smooth' : 'auto' });
  }
  if ('onscrollend' in window) {
    strip.addEventListener('scrollend', function () {
      clearTimeout(zarIdozito);
      zarva = false;
    });
  }

  /* Nincs szures - minden szin es minden lifestyle kep vegig lathato. A
     szinvalasztas a varians jelolt kepere ugrik (data-varszin) - ha az
     adminban nincs kep a varianshoz, nem ugrunk. */
  function frissit(ugorjon) {
    var szin = aktivSzin();
    if (ugorjon !== false && szin) {
      var cel = -1;
      slides.some(function (s, i) {
        if ((s.getAttribute('data-varszin') || '') === szin) { cel = i; return true; }
        return false;
      });
      if (cel > -1) ugrik(cel, true);
    }
    jelzo();
  }

  function jelzo() {
    var max = strip.scrollWidth - strip.clientWidth;
    gal.classList.toggle('is-single', max < 4);
    if (max < 4) { prog.classList.add('is-hidden'); return; }
    prog.classList.remove('is-hidden');
    var w = Math.max(18, (strip.clientWidth / strip.scrollWidth) * 100);
    progCsik.style.width = w + '%';
    progCsik.style.left = ((strip.scrollLeft / max) * (100 - w)) + '%';
  }

  /* sin-kattintas -> a strip odalapoz, es a szin is kovet (a belyegre
     kattintas ugyanolyan kepvalasztas, mint a lapozas) */
  picks.forEach(function (p, i) {
    p.addEventListener('click', function () { ugrik(i, true); szinKovet(i); });
  });

  /* strip-gorgetes (swipe) -> a sin koveti, de csak MEGALLAS utan (debounce):
     menet kozben nem valt, igy nincs ugralo kijeloles */
  var csendVar = null;
  strip.addEventListener('scroll', function () {
    jelzo();
    if (zarva) return;
    clearTimeout(csendVar);
    csendVar = setTimeout(function () {
      var rc = strip.getBoundingClientRect(), kozep = rc.left + rc.width / 2;
      var best = -1, tav = Infinity;
      slides.forEach(function (s, i) {
        var r = s.getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - kozep);
        if (d < tav) { tav = d; best = i; }
      });
      if (best > -1) { kiemel(best); szinKovet(best); }
    }, 130);
  }, { passive: true });

  window.addEventListener('resize', jelzo);
  gal.querySelectorAll('[data-gnav]').forEach(function (b) {
    b.addEventListener('click', function () {
      strip.scrollBy({ left: (+b.getAttribute('data-gnav')) * strip.clientWidth, behavior: 'smooth' });
    });
  });

  /* Igaz-e, hogy a megvaltozott input a SZIN-csoportba tartozik? A
     meretvalasztas nem befolyasolhatja a kepvalasztast. */
  function szinCsoportbol(el) {
    var opt = gal.getAttribute('data-color-option');
    if (!opt || !el || !el.closest) return false;
    var box = el.closest('fieldset, .product-form__input');
    if (!box) return false;
    var lg = box.querySelector('legend, .form__label');
    return !!lg && norm(lg.textContent).indexOf(norm(opt)) === 0;
  }

  /* varians-valtas: a Dawn a form inputjaival dolgozik, a section-frissites utan is kell.
     CSAK szinvaltaskor ugrunk a galeriaban; meret- (es barmely mas) valtozasnal a kep
     marad ott, ahol a vevo hagyta. */
  document.addEventListener('change', function (e) {
    if (!(e.target.closest && e.target.closest('variant-selects, .product-form__input'))) return;
    if (!szinCsoportbol(e.target)) return;
    /* a galeriabol inditott szinvaltasnal NEM gorgetunk vissza a szin elso
       fotojara - a vevo azon a kepen marad, amire lapozott */
    if (belsoValtas) { belsoValtas = false; return; }
    setTimeout(function(){ frissit(true); }, 40);
  });

  frissit(true);
})();
